import type { ReactNode } from 'react';
import { styles } from '@/shared/app-stepper-form/styles';
import { StepPanelHeader } from '@/shared/app-stepper-form/parts/step-panel-header';
import { StepPanelFooter } from '@/shared/app-stepper-form/parts/step-panel-footer';
import type { StepperPanelProps } from '@/shared/app-stepper-form/types';

/**
 * The right-hand panel: the active step's header, its scrolling body, and the
 * pinned footer.
 *
 * WHY IT IS ITS OWN PART
 * ----------------------
 * The panel is where the fixed-height contract is enforced, and that contract is
 * the whole reason this layout exists. Keeping it in one file means the three
 * pieces that must agree — a header that does not scroll, a body that does, and a
 * footer that never moves — are read together rather than assembled from three
 * places in a parent.
 */
export function StepperPanel({
  step,
  steps,
  states,
  index,
  furthestReached,
  isFirst,
  isLast,
  canAdvance,
  isSubmitting,
  submitLabel,
  cancelLabel,
  submitError,
  onCancel,
  onBack,
  onAdvance,
  onSubmit,
  onJump,
}: StepperPanelProps): ReactNode {
  return (
    <div className={styles.panel}>
      <StepPanelHeader
        step={step}
        steps={steps}
        states={states}
        index={index}
        furthestReached={furthestReached}
        onJump={onJump}
      />

      <div className={styles.panelBody}>{step.content}</div>

      <StepPanelFooter
        submitError={submitError}
        isFirst={isFirst}
        isLast={isLast}
        canAdvance={canAdvance}
        isSubmitting={isSubmitting}
        submitLabel={submitLabel}
        cancelLabel={cancelLabel}
        onCancel={onCancel}
        onBack={onBack}
        onAdvance={onAdvance}
        onSubmit={onSubmit}
      />
    </div>
  );
}
